import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAddMenuNetoMutation, useGetMenuNetoQuery } from './menuNetoApiSlice';

import errorFormat from '../../../../../utils/errorFormat';
import { ISmenuNeto, MenuNeto, MenuNetoDTO } from '../../../../../typesSite/menuneto/MenuNeto';
import TxtMenuFilhoSite from '../../../../autoComplete/TxtMenuFilhoSite';
import { ISmenuFilho, MenuFilho, MenuFilhoList } from '../../../../../typesSite/menuFilho/MenuFilho';
import TxtNoticiaSite from '../../../../autoComplete/TxtNoticiaSite';
import { Noticia } from '../../../../../typesSite/noticia/Noticia';

export const MenuNetoCreate = () => {
  const [menuNeto, SetMenuNeto] = useState<MenuNeto>(ISmenuNeto);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createMenuNeto, status] = useAddMenuNetoMutation();
  const navigate = useNavigate();

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetMenuNetoQuery(id);
  useEffect(() => {
    if (data) {
      SetMenuNeto(data);
    }
  }, [data, error, isFetching]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    SetMenuNeto(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    //e.preventDefault();
    if (!menuNeto.menuFilho || !menuNeto.menuFilho.id) {
      enqueueSnackbar('O Menu nível 2 deve ser informado!', { variant: 'warning' });
      return;
    }

    const parms: MenuNetoDTO = {
      id: menuNeto.id,
      label: menuNeto.label,
      link: menuNeto.link || '',
      idFilho: menuNeto.menuFilho?.id || '',
      idNoticia: menuNeto.noticia?.id || '',
      ordem: menuNeto.ordem || 0,
      isEscolaLegislativo: menuNeto.menuFilho?.menuPai.isEscolaLegislativo || false
    };

    await createMenuNeto(parms);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  const [menuFilhoSelecionado, setMenuFilhoSelecionado] = useState<MenuFilho>(ISmenuFilho);

  const handletxtMenuFilhoChange = (menuFilho: MenuFilho) => {
    setMenuFilhoSelecionado(menuFilho as MenuFilho);
    SetMenuNeto(prev => ({
      ...prev,
      menuFilho: menuFilho as MenuFilhoList
    }));
  };

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          width: {
            xs: '100%', // 100% em telas pequenas
            sm: '90%', // 90% em telas médias ou maiores
            md: '90%',
            lg: '90%'
          },
          maxWidth: '1200px', // Limite opcional
          p: 2
        }}
      >
        <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
          {menuNeto.id ? 'Edição' : 'Inclusão'} Sub Menu nível 3
        </Typography>

        <Box mt={2} p={2}>
          <form onSubmit={handleSubmit} method="POST">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" gap={2}>
                  <FormControl fullWidth>
                    <TxtMenuFilhoSite
                      isdisabled={false}
                      value={menuNeto.menuFilho}
                      handleSearchChange={it => {
                        handletxtMenuFilhoChange(it);
                      }}
                    />
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Titulo do Menu"
                    name="label"
                    onChange={handleChange}
                    size="small"
                    inputProps={{ maxLength: 30 }}
                    value={menuNeto.label}
                    //multiline // Adiciona o suporte a múltiplas linhas
                    //rows={4}
                  />
                  <FormHelperText>{menuNeto.label?.length}/30 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField label="Link para o Menu" name="link" onChange={handleChange} size="small" inputProps={{ maxLength: 255 }} value={menuNeto.link} />
                  <FormHelperText>{menuNeto.link?.length}/255 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label="Ordem do Link no Menu"
                    name="ordem"
                    onChange={handleChange}
                    size="small"
                    inputProps={{
                      maxLength: 3,
                      inputMode: 'numeric', // para dispositivos móveis
                      pattern: '[0-9]*' // restringe a números
                    }}
                    value={menuNeto.ordem || ''}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" gap={2}>
                  <FormControl fullWidth>
                    <TxtNoticiaSite
                      isdisabled={false}
                      value={menuNeto.noticia as Noticia}
                      handleSearchChange={it => {
                        SetMenuNeto(prev => ({
                          ...prev,
                          noticia: it as Noticia
                        }));
                      }}
                    />
                  </FormControl>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" gap={2}>
                  <Button type="submit" variant="contained" color="secondary">
                    Gravar
                  </Button>

                  <Button variant="contained" onClick={() => navigate(-1)}>
                    Voltar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Paper>
    </>
  );
};
